import { memo } from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import type { Collection } from "@/hooks/useCollections";

interface CollectionCardProps {
  collection: Collection;
  variant?: "default" | "compact";
  eager?: boolean;
}

const CollectionCard = memo(({ collection, variant = "default", eager = false }: CollectionCardProps) => {
  const isCompact = variant === "compact";
  
  return (
    <Link
      to={`/coleccion/${collection.slug}`}
      className={cn(
        "group block overflow-hidden rounded-2xl transition-all duration-300",
        "hover:shadow-xl hover:-translate-y-1",
        "shadow-sm"
      )}
    >
      <div className="relative aspect-[16/9] md:aspect-[16/7]">
        {collection.cover_image ? (
          <img
            src={collection.cover_image}
            alt={collection.name}
            width={600}
            height={263}
            loading={eager ? "eager" : "lazy"}
            fetchPriority={eager ? "high" : "auto"}
            decoding={eager ? "sync" : "async"}
            className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-primary/80 via-primary/60 to-accent/50" />
        )}
      </div>
      <h3 className="text-sm font-semibold text-foreground text-center py-2 px-3 bg-card">
        {collection.name}
      </h3>
    </Link>
  );
});

CollectionCard.displayName = 'CollectionCard';

export default CollectionCard;
